module.exports = __webpack_public_path__ + "img/calendar-plus.35600a04.svg";